import styled, { DefaultTheme } from 'styled-components';

export const Icon = styled.div<{
  colorSVG: keyof DefaultTheme['colors'];
}>`
  height: 100%;
  display: flex;
  align-items: center;
  padding-right: 15px;
  svg {
    fill: ${({ colorSVG, theme }) => theme.colors[colorSVG]} !important;
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 8rem;
`;
export const StyledCard = styled.div`
  flex: 1;
  padding: 20px;
  text-align: center;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  position: relative;
  background: ${({ theme }) => theme.colors.background};
`;

export const AvatarWrapper = styled.div`
  position: relative;
  margin-right: -30px;
  z-index: 1;
  background-color: transparent;
  border-radius: 50%;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CardHeader = styled.div`
  display: flex;
  max-width: 100%;
  justify-content: space-between;
  margin: 0 0 0 20px;

  .name {
    max-width: 10rem;
  }

  span {
    display: block;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.colors.secondary};
  }
`;

export const CardContent = styled.div`
  display: flex;
  max-width: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 0 20px;

  button {
    color: ${({ theme }) => theme.colors.secondary};
  }
  p {
    color: ${({ theme }) => theme.colors.text_gray};
  }
`;
